(function() {
  
  const STORAGE_KEY = 'product_custom_options';
  let saveTimeout = null;
  let appliedSuccessfully = false;
  let isInitialized = false;
  
  
  // Get URL parameters
  function getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    
    if (urlParams.has('height')) {
      params.height = parseFloat(urlParams.get('height')).toFixed(1);
    }
    
    if (urlParams.has('width')) {
      params.width = parseFloat(urlParams.get('width')).toFixed(1);
    }
    
    return Object.keys(params).length > 0 ? params : null;
  }
  
  // Format number to one decimal place
  function formatToOneDecimal(value) {
    if (!value || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toFixed(1);
  }
  
  // Trigger all possible events to ensure plugin responds
  function triggerAllEvents(input) {
    // Create and dispatch various events that the plugin might listen to
    const events = ['input', 'change', 'keyup', 'blur'];
    
    events.forEach(eventType => {
      const event = new Event(eventType, { 
        bubbles: true,
        cancelable: true 
      });
      input.dispatchEvent(event);
    });
    
    // Also try jQuery trigger if jQuery is available
    if (window.jQuery) {
      jQuery(input).trigger('change').trigger('input');
    }
  }
  
  // Create loading overlay
  function createLoadingIndicator() {
    const loadingHTML = `
      <div id="custom-options-loader" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        opacity: 1;
        transition: opacity 0.3s ease;
      ">
        <div style="
          text-align: center;
          padding: 30px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          max-width: 300px;
        ">
          <div style="
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #333;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 20px;
          "></div>
          <p style="
            margin: 0;
            font-size: 16px;
            color: #333;
            font-weight: 500;
          ">Lade gespeicherte Werte...</p>
          <p style="
            margin: 10px 0 0;
            font-size: 13px;
            color: #666;
          ">Einen Moment bitte</p>
        </div>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
    
    document.body.insertAdjacentHTML('beforeend', loadingHTML);
    return document.getElementById('custom-options-loader');
  }
  
  // Hide loading indicator
  function hideLoadingIndicator(loader) {
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => {
        loader.remove();
      }, 300);
    }
  }
  
  function initProductOptions() {
    
    if (isInitialized) {
      return false;
    }

    const optionsContainer = document.querySelector('.cl-po--options');
    
    if (!optionsContainer) {
      return false;
    }
    
    const inputs = optionsContainer.querySelectorAll('.cl-po--input');
    
    if (inputs.length === 0) {
      return false;
    }

    isInitialized = true;
    
    // Debounced save function
    function saveValues() {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(() => {
        const values = {};
        
        inputs.forEach(input => {
          const key = input.name || input.id;
          if (input.name && input.name.includes('_Dimensionen_')) {
            if (input.value) {
              if (input.name.includes('_x')) {
                values.height = formatToOneDecimal(input.value);
              } else if (input.name.includes('_y')) {
                values.width = formatToOneDecimal(input.value);
              }
            }
          }
        });
        
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values));
      }, 300);
    }
    
    // Apply saved values
    function applyValues(values, isFromUrl = false) {
      
      // Temporarily disable saving during apply
      appliedSuccessfully = false;
      
      inputs.forEach(input => {
        const inputName = input.name || input.id;
        
        // Apply height (Höhe - Dimensionen_x)
        if (inputName.includes('_Dimensionen_x') && values.height) {
          input.value = formatToOneDecimal(values.height);
        }
        
        // Apply width (Breite - Dimensionen_y)
        else if (inputName.includes('_Dimensionen_y') && values.width) {
          input.value = formatToOneDecimal(values.width);
        }
        
        // If from URL, reset Schattenfuge and Bildtiefe to defaults
        if (isFromUrl) {
          if (inputName.includes('Schattenfugenbreite')) {
            input.value = '0.7';
          } else if (inputName.includes('Bildtiefe')) {
            input.value = '1.0';
          }
        }
      });
      
      // Trigger events with delays to ensure plugin catches them
      setTimeout(() => {
        
        inputs.forEach((input, index) => {
          const inputName = input.name || input.id;
          
          // Only trigger events on Dimensionen inputs (for price calculation)
          if (inputName.includes('_Dimensionen_')) {
            // Stagger the events slightly for each input
            setTimeout(() => {
              triggerAllEvents(input);
            }, index * 100);
          }
        });
        
        // Re-enable saving after all events are done
        setTimeout(() => {
          appliedSuccessfully = true;
        }, 1000);
      }, 200);
    }
    
    // Watch for when inputs are actually ready and visible
    function waitForInputsReady(callback) {
      let checkCount = 0;
      const maxChecks = 50;
      
      const checkInterval = setInterval(() => {
        checkCount++;
        
        const allReady = Array.from(inputs).every(input => {
          const rect = input.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && !input.disabled;
        });
        
        if (allReady) {
          clearInterval(checkInterval);
          callback();
        } else if (checkCount >= maxChecks) {
          clearInterval(checkInterval);
          callback();
        }
      }, 200);
    }
    
    // Main load function
    function loadValues() {
      
      // Check URL params first (highest priority)
      const urlParams = getUrlParams();
      
      if (urlParams) {
        const loader = createLoadingIndicator();
        
        // Save URL params to sessionStorage
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(urlParams));
        
        waitForInputsReady(() => {
          setTimeout(() => {
            applyValues(urlParams, true); // true = from URL, reset other fields
            
            setTimeout(() => {
              // Final reapply to ensure values stick
              inputs.forEach(input => {
                const inputName = input.name || input.id;
                
                if (inputName.includes('_Dimensionen_x') && urlParams.height) {
                  input.value = formatToOneDecimal(urlParams.height);
                  triggerAllEvents(input);
                } else if (inputName.includes('_Dimensionen_y') && urlParams.width) {
                  input.value = formatToOneDecimal(urlParams.width);
                  triggerAllEvents(input);
                }
              });
              
              appliedSuccessfully = true;
              hideLoadingIndicator(loader);
            }, 1000);
          }, 1000);
        });
        
        return;
      }
      
      // If no URL params, check sessionStorage
      const savedData = sessionStorage.getItem(STORAGE_KEY);
      
      if (!savedData) {
        return;
      }
      
      const loader = createLoadingIndicator();
      
      try {
        const values = JSON.parse(savedData);
        
        waitForInputsReady(() => {
          setTimeout(() => {
            applyValues(values, false); // false = from storage, keep other fields
            
            let needsReapply = false;
            
            inputs.forEach(input => {
              const inputName = input.name || input.id;
              
              if (inputName.includes('_Dimensionen_x') && values.height && input.value !== formatToOneDecimal(values.height)) {
                needsReapply = true;
              } else if (inputName.includes('_Dimensionen_y') && values.width && input.value !== formatToOneDecimal(values.width)) {
                needsReapply = true;
              }
            });
            
            if (needsReapply) {
              applyValues(values, false);
              
              setTimeout(() => {
                inputs.forEach(input => {
                  const inputName = input.name || input.id;
                  
                  if (inputName.includes('_Dimensionen_x') && values.height && input.value !== formatToOneDecimal(values.height)) {
                    input.value = formatToOneDecimal(values.height);
                    triggerAllEvents(input);
                  } else if (inputName.includes('_Dimensionen_y') && values.width && input.value !== formatToOneDecimal(values.width)) {
                    input.value = formatToOneDecimal(values.width);
                    triggerAllEvents(input);
                  }
                });
                appliedSuccessfully = true;
                hideLoadingIndicator(loader);
              }, 1000);
            } else {
              appliedSuccessfully = true;
              hideLoadingIndicator(loader);
            }
          }, 1000);
        });
        
      } catch (e) {
        console.error('[DEBUG] Error loading saved data:', e);
        hideLoadingIndicator(loader);
      }
    }
    
    // Load values (URL params or saved values)
    loadValues();
    
    // Format input on blur (when user leaves the field)
    inputs.forEach(input => {
      const inputName = input.name || input.id;
      
      // Only apply to Dimensionen inputs
      if (inputName.includes('_Dimensionen_')) {
        input.addEventListener('blur', (e) => {
          if (input.value && input.value !== '') {
            const formatted = formatToOneDecimal(input.value);
            if (input.value !== formatted) {
              input.value = formatted;
              triggerAllEvents(input);
            }
          }
        });
      }
      
      input.addEventListener('focus', () => {
        appliedSuccessfully = true;
      });
      
      input.addEventListener('input', (e) => {
        if (appliedSuccessfully) {
          saveValues();
        }
      });
      
      input.addEventListener('change', (e) => {
        if (appliedSuccessfully) {
          saveValues();
        }
      });
    });
    
    return true;
  }
  
  // Strategy 1: Try immediately in case elements are already present
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductOptions();
    });
  } else {
    initProductOptions();
  }

  // Strategy 2: Use MutationObserver to watch for the element appearing
  const observer = new MutationObserver((mutations, obs) => {
    // Skip if already initialized
    if (isInitialized) {
      return;
    }
    
    const optionsContainer = document.querySelector('.cl-po--options');
    
    if (optionsContainer && !isInitialized) {
      // Wait a bit for inputs to be ready
      setTimeout(() => {
        if (initProductOptions()) {
          obs.disconnect(); // Stop observing once initialized
        }
      }, 500);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Strategy 3: Fallback timeout (in case MutationObserver misses it)
  setTimeout(() => {
    if (!isInitialized) {
      initProductOptions();
    }
  }, 3000);

  // Strategy 4: Additional fallback for very slow loading
  setTimeout(() => {
    if (!isInitialized) {
      initProductOptions();
    }
  }, 5000);
  
})();